import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { fetchShootingDays } from "./ducks/actions";
import Loader from "./../../shared/loader";

function DefaultRedirect(props) {
    const filmId = props.match.params.filmId;
    const { fetchShootingDays, loading, hasDays } = props;

    useEffect(() => {
        fetchShootingDays(filmId);
    }, [filmId, fetchShootingDays]);

    if (loading) {
        return <Loader />;
    }

    if (!hasDays) {
        return <Redirect to={`/films/${filmId}/shooting-days/shooting-order`} />;
    }

    // If there are days, don't redirect (this case shouldn't happen as routes should match more specific paths first)
    return null;
}

function mapStateToProps(state) {
    const { rootState } = state.shootingdaysState;
    return {
        hasDays: rootState.hasDays,
        loading: rootState.loading
    };
}

export default connect(mapStateToProps, {
    fetchShootingDays
})(DefaultRedirect);
